import React, { useState } from 'react'
import styles from './styles.module.css'
import noname from '../../../assets/images/noname.png'
import { IoMdCreate, IoMdTrash, IoMdUndo } from 'react-icons/io'
import { deleteMessage, editMessage } from '../../../actions/FAQ'
import { useDispatch } from 'react-redux'
import Confirmation from '../../../components/Confirmation/Confirmation'
import { API_BASE_URL } from '../../../assets/const'
import moment from 'moment'

const dateFormat = 'DD.MM.YYYY, HH:mm'

const Index = ({ item, isDeLete, onReply, isMine }) => {
    const dispatch = useDispatch()
    const [confirmation, setConfirmation] = useState(false)
    const [editText, setEditText] = useState(null) // null = не редактируем

    const acceptConfirmation = () => {
        dispatch(deleteMessage(confirmation.id, confirmation.chat))
        setConfirmation(false)
    }

    const handleSaveEdit = () => {
        if (editText && editText.trim().length >= 1) {
            dispatch(editMessage({ message: editText }, item.chat, item.id, [], []))
        }
        setEditText(null)
    }

    const files = item.files || []

    return (
        <div className={`${styles.msg}${isMine ? ' ' + styles.mine : ''}`}>
            {confirmation && (
                <Confirmation
                    top="30px"
                    left="40px"
                    title="Удалить сообщение?"
                    confirmation={confirmation.message}
                    acceptConfirmation={acceptConfirmation}
                    rejectConfirmation={() => setConfirmation(false)} />
            )}

            <img
                className={styles.avatar}
                src={item.photo ? `data:image/png;base64, ${item.photo}` : noname}
                alt=""
            />

            {editText !== null ? (
                <div className={styles.editBox}>
                    <textarea
                        value={editText}
                        onChange={e => setEditText(e.target.value)}
                        autoFocus
                    />
                    <div className={styles.editActions}>
                        <button className={styles.btnSave} onClick={handleSaveEdit}>Сохранить</button>
                        <button className={styles.btnCancel} onClick={() => setEditText(null)}>Отмена</button>
                    </div>
                </div>
            ) : (
                <div className={styles.body}>
                    <div className={styles.sender}>{item.from_user}</div>
                    <div className={styles.text}>{item.message}</div>
                    {files.map(file => (
                        <a
                            key={file.file_name}
                            className={styles.attachChip}
                            href={`${API_BASE_URL}/faq/${item.chat}/messages/${item.id}/files/${file.file_name}`}
                            target="_blank"
                            rel="noreferrer">
                            📎 {file.file_name}
                        </a>
                    ))}
                </div>
            )}

            <div className={styles.tools}>
                <span className={styles.time}>{moment(item.created).format(dateFormat)}</span>
                <div className={styles.btnRow}>
                    <button className={styles.ic} title="Ответить" onClick={() => onReply(item)}>
                        <IoMdUndo />
                    </button>
                    {isDeLete && (
                        <button className={styles.ic} title="Редактировать" onClick={() => setEditText(item.message)}>
                            <IoMdCreate />
                        </button>
                    )}
                    {isDeLete && (
                        <button className={`${styles.ic} ${styles.danger}`} title="Удалить" onClick={() => setConfirmation(item)}>
                            <IoMdTrash />
                        </button>
                    )}
                </div>
            </div>
        </div>
    )
}

export default Index
